import script from "./PtoConfigTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PtoConfigTable.vue?vue&type=script&setup=true&lang=ts"

import "./PtoConfigTable.vue?vue&type=style&index=0&id=3d5b7e58&lang=css"

const __exports__ = script;

export default __exports__